/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import ChannelHeader from './ChannelHeader.react';
import "./channel.scss";
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';

import {wrapNotFound} from '../app/NotFoundHandler.react';
import * as Tool from '../fw/Tool';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import {getUrlForChannelCreate} from './getUrlForChannelCreate';
import { createChannelFromChannelDef } from './ChannelAddStep1.react';
import { getQueryParams } from '../../common/util/QueryParams';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddStep1.addTitle', 'defaultMessage': 'Adding My App'}
});

interface ChannelAddAutoProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ChannelAddAuto extends React.Component<ChannelAddAutoProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    typeName = 'channels';

    static contextTypes = {
        router: PropTypes.object
    };

	constructor(props) {
		super(props);

        this.state = {
            isCreating: false,
        };

        this.componentWillReceiveProps(props);
	}

    componentDidMount() {
        LoadingLine.start();
    }

    componentWillReceiveProps(props) {
        if (this.variableSet) {
            return;
        }

        if (props.user.channelDefs && props.user.channelDefs.edges && props.user.channelDefs.edges.length > 0) {
            let channelDef = props.user.channelDefs.edges[0].node;

            this.variableSet = true;
            this.props.relay.setVariables({
                channelDefId: channelDef.realId,
            });
        }
    }

    _create = () => {
        if (this.state.isCreating) {
            return;
        }

        this.setState({
            isCreating: true,
        });

        let {channelDef} = this.props.user;

        if (!channelDef) {
            channelDef = this.props.user.channelDefs.edges[0].node;
        }

        if (!this.props.user.organisation) {
            return;
        }

        let options = getQueryParams(window.location.search || '') || {};

        return createChannelFromChannelDef(channelDef, this.props.user.organisation, false, options).then((channel) => {
            let path = getUrlForChannelCreate(this.props.user.organisation, channel, channelDef, this.props.user.scenario) + (document.location.search ? document.location.search : "");
            this.context.router.push(path);
        });
    };

    render() {
        let {channelDef} = this.props.user;

        if (!channelDef) {
            channelDef = this.props.user.channelDefs.edges[0].node;
        }

        if (this.props.user.organisation && channelDef) {
            this._create();
        }

		let metadata = types['channelDefs'];
		let tagsTag = null;
        let columnMapping = Tool.getMappingForColumn('state', metadata.fields());
        let tags = Tool.getDataForColumn('state', metadata.fields(), channelDef);
        if (tags) {
            if (!('hide' in columnMapping['values'][tags]) && !columnMapping['values'][tags].hide) {
                let style = {};
                if (columnMapping['values'][tags].color) {
                    style['backgroundColor'] = columnMapping['values'][tags].color;
                }
                tagsTag = (
                    <span className="badge" style={style}>{Tool.tranformDataForView(metadata.entity(), columnMapping, this.props.intl.formatMessage, tags, true)}</span>);
            }
        }

		let content = (<div>
			<ChannelHeader data={channelDef} isChannelDef organisation={this.props.user.organisation} tag={tagsTag} title={channelDef.name} />

		</div>);

        return (
            <AppPanel breadcrumbParams={[
                {type: types['channelDefs'], data: channelDef},
                {type: types['scenarios'], data: this.props.user.scenario},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <LoadingLine />
                {content}
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddAuto), (props) => {
    return (props.user.channelDefs && props.user.channelDefs.edges.length > 0) || props.user.channelDef;
}), {
    initialVariables: {
        channelDefId: '',
        channelDefUrlFragment: '',
        channelDefIdSelected: false,
        channelDefUrlFragmentSelected: false,
        organisationId: '',
        organisationSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }
        variables['organisationSelected'] = variables['organisationId'] ? true : false;
        variables['channelDefIdSelected'] = variables['channelDefId'] ? true : false;
        variables['channelDefUrlFragmentSelected'] = variables['channelDefUrlFragment'] ? true : false;
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                firstname,
                surname,
                email,
                organisation(id: $organisationId) @include(if: $organisationSelected) {
                    id,
                    realId,
                    name,
                    users(first: 2) {
                        edges {
                            node {
                                id,
                                realId
                            }
                        }
                    },
                    channels(channelDef: $channelDefId, first: 1) @include(if: $channelDefIdSelected) {
                        edges {
                            node {
                                id,
                                realId,
                                channelDef_id,
                                activated,
                                enabled,
                            }
                        }
                    }
                },
                organisations(first: 20) {
                    edges {
                        node {
                            id,
                            realId,
                            name
                        }
                    }
                },
                channelDef: publicChannelDef(id: $channelDefId) @include(if: $channelDefIdSelected) {
                    id,
                    realId,
                    metadata,
                    description,
                    addType,
                    authType,
                    showContactUs,
                    longDescription,
                    connectRequirement,
                    canBeAddedOnce,
                    requiresAgent,
                    canUseAgent,
                    name,
                    icon
                },
                channelDefs: publicChannelDefs(first: 1, urlFragment: $channelDefUrlFragment) @include(if: $channelDefUrlFragmentSelected) {
                    edges {
                        node {
                            id,
                            realId,
                            metadata,
                            description,
                            addType,
                            authType,
                            showContactUs,
                            longDescription,
                            connectRequirement,
                            canBeAddedOnce,
                            requiresAgent,
                            canUseAgent,
                            name,
                            icon
                        }
                    }
                }
            }
        `,
    },
});
